import makeStyles from '@material-ui/core/styles/makeStyles';
export var useStyles = makeStyles({
    wrapper: {
        height: '43px',
        width: '100%',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.57)',
        '& div:first-child': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: 700,
            color: '#FFFFFF',
        },
    },
    positionFixed: {
        position: 'fixed',
        top: 165,
        zIndex: 10,
    },
    name: {
        minWidth: '65%',
        marginRight: '15px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    groupName: {
        marginRight: 17,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    userCardIsVisible: {
        height: '100%',
        padding: '0 75px 0 17px',
        fontSize: '22px',
        transition: 'all 0.3s ease-in-out',
        '& div': {
            justifyContent: 'flex-end',
        },
    },
    userCardIsHidden: {
        height: '100%',
        padding: '0 40px 0 25px',
        fontSize: '14px',
        fontWeight: 700,
        color: '#FFFFFF',
        transition: 'all 0.3s ease-in-out',
        '& span:first-child': {
            width: 'fit-content',
            maxWidth: '50%',
            minWidth: '20%',
            marginRight: 0,
        },
    },
    '@keyframes fadeIn': {
        '0%': {
            height: 0,
            fontSize: 0,
        },
        '100%': {
            height: '100%',
            fontSize: '22px',
        },
    },
    fadeInActive: {
        animation: '$fadeIn 0.3s ease-in-out',
    },
    level: {
        color: '#6CFF00',
    },
    balance: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '12px',
        color: '#6CFF00',
        '& svg': {
            marginLeft: '5px',
        },
        '& img': {
            marginLeft: '5px',
            height: '16px',
        }
    },
    noPaddingRight: {
        paddingRight: 0,
    },
    halfWidth: {
        minWidth: '50%',
    }
}, { name: 'UserCardCartoonHeader' });
